<template>
  <v-app>
    <v-app-bar app color="gray" dark>
      <v-btn to="/" small text>Joe Radman</v-btn>

      <v-spacer></v-spacer>
      <v-btn
        href="https://www.facebook.com/joeradman"
        target="_blank"
        small
        text
      >
        <span class="mr-2">Facebook</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer app>
      <span>&copy; 2021</span>
      <v-spacer></v-spacer>
      <template v-if="user.loggedIn">
        <div class="nav-item">{{ user.data.displayName }}</div>
        <v-btn @click.prevent="signOut" x-small text>Sign out</v-btn>
      </template>
      <template v-else>
        <v-btn to="login" x-small text>Login</v-btn>
      </template>
    </v-footer>
  </v-app>
</template>

<script>
const fb = require("./utils/firebaseConfig.js");

export default {
  name: "App",

  components: {},
  computed: {
    user: function () {
      return this.$store.getters.user;
    },
  },
  created() {
    this.$vuetify.theme.dark = true;
  },
  methods: {
    signOut() {
      fb.auth.signOut().then(() => {
        this.$router.replace({
          name: "home",
        });
      });
    },
  },
  data: () => ({
    //
  }),
};
</script>
